<script setup>
  import { ref } from 'vue';

  import HomeSectionHeading from '@/components/home/HomeSectionHeading.vue';

  import { HOME_VIDEO } from '@/constants/home';

  import houseIcon from '@/assets/images/home/icon-section-house.svg';
  import videoCover from '@/assets/images/home/video-cover.webp';
  import playIcon from '@/assets/images/home/video-play.svg';

  const videoElement = ref(null);
  const isStarted = ref(false);

  // play() inside the click handler, otherwise iOS Safari blocks it
  const playVideo = () => {
    isStarted.value = true;
    videoElement.value.play();
  };
</script>

<template>
  <section class="w-full">
    <div
      class="mx-auto flex w-full max-w-299 flex-col items-center px-5 pt-14 pb-15 md:px-8 md:pt-24 md:pb-24 xl:px-0 xl:pt-34 xl:pb-34"
    >
      <img :src="houseIcon" alt="" class="size-10 md:size-12 lg:size-13" />
      <HomeSectionHeading v-reveal class="mt-5" :title="HOME_VIDEO.title" />

      <div
        v-reveal="100"
        class="relative -mx-5 mt-15 aspect-402/361 self-stretch overflow-hidden bg-black md:mx-0 md:aspect-video lg:mt-17"
      >
        <video
          v-show="isStarted"
          ref="videoElement"
          :src="HOME_VIDEO.src"
          class="size-full object-contain"
          preload="none"
          playsinline
          controls
        />

        <button
          v-if="!isStarted"
          type="button"
          class="group absolute inset-0 cursor-pointer"
          :aria-label="HOME_VIDEO.playLabel"
          @click="playVideo"
        >
          <img
            :src="videoCover"
            alt=""
            width="1920"
            height="1080"
            loading="lazy"
            class="size-full object-cover"
          />
          <span class="absolute inset-0 bg-black/55" />
          <span
            v-for="ring in 2"
            :key="ring"
            class="play-ring absolute top-1/2 left-1/2 size-20 -translate-1/2 rounded-full md:size-28 lg:size-37.5"
            :style="{ animationDelay: `${(ring - 1) * 1.2}s` }"
          />
          <img
            :src="playIcon"
            alt=""
            class="absolute top-1/2 left-1/2 size-20 -translate-1/2 transition-transform duration-300 group-hover:scale-105 md:size-28 lg:size-37.5"
          />
        </button>
      </div>
    </div>
  </section>
</template>

<style scoped>
  .play-ring {
    background: var(--color-blue-light);
    animation: play-ring 2.4s ease-out infinite;
  }

  @keyframes play-ring {
    from {
      opacity: 0.5;
      scale: 1;
    }
    to {
      opacity: 0;
      scale: 1.6;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .play-ring {
      display: none;
    }
  }
</style>
